import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectAccessToken } from "../../../selectors/userSelectors";
import { wsManager } from "../../../websocket/wsManager";
import { PRESENCE_SUBSCRIBE_MAX_IDS } from "../model/presenceConstants";

function normalizeIds(userIds) {
  if (!Array.isArray(userIds)) return [];
  const out = [];
  const seen = new Set();
  for (const raw of userIds) {
    const n = typeof raw === "number" ? raw : Number(raw);
    if (!Number.isSafeInteger(n) || n <= 0) continue;
    if (seen.has(n)) continue;
    seen.add(n);
    out.push(n);
    if (out.length >= PRESENCE_SUBSCRIBE_MAX_IDS) break;
  }
  return out;
}

/**
 * Bound the currently rendered presence surface's desired watch set.
 * Ownership of reconnect replay lives in wsManager — this hook only reconciles
 * the latest desired IDs (including empty cleanup on unmount / logout).
 */
export default function usePresenceSubscription(userIds) {
  const accessToken = useSelector(selectAccessToken);
  const ids = useMemo(() => normalizeIds(userIds), [userIds]);
  const idsKey = ids.join(",");

  useEffect(() => {
    if (!accessToken) {
      wsManager.setDesiredPresenceSubscription([]);
      return undefined;
    }

    wsManager.setDesiredPresenceSubscription(ids);

    return () => {
      wsManager.setDesiredPresenceSubscription([]);
    };
  }, [accessToken, ids, idsKey]);
}
